import { useState, useEffect } from "react";
import swal from 'sweetalert2';
import * as helper from '../global/helper';
import { postVendorUser } from "../api/vendorAPI";

const AddVendorUserModal = ({ show, onDismissModal, vendorID, vendorUserData, onSave }) => {

    const [vendorUser, setVendorUser] = useState({ Status: 1 });

    useEffect(() => {
        if (show) {
            setVendorUser(vendorUserData ? { ...vendorUserData } : { Status: 1 });
            $('#vendor-user-add-modal').modal({ backdrop: 'static' });
            $('#vendor-user-add-modal').on('hidden.bs.modal', function () {
                onDismissModal();
            });
            $('#vendor-user-add-modal').modal('show');
        } else {
            $('#vendor-user-add-modal').modal('hide');
        }
    }, [show]);

    const updateVendorUserField = (field, value) => {
        setVendorUser((d) => ({ ...d, [field]: value }));
    };

    const addVendorUserHandler = async () => {
        const btn  = $('#btnSaveVendorUser');
        const form = $('#add-vendor-user-form');

        form.validate({
            rules: {
                txtUserName  : { required: true },
                txtUserEmail : { required: true, email: true },
                txtUserPhone : { required: true, minlength: 10, maxlength: 15, digits: true },
            },
            messages: {
                txtUserName  : { required: "Please enter name" },
                txtUserEmail : { required: "Please enter email", email: "Please enter a valid email" },
                txtUserPhone : { required: "Please enter phone number", minlength: "Minimum 10 digits required", digits: "Only digits allowed" },
            },
        });

        if (!form.valid()) return;
        helper.StartProcessing(btn);

        try {
            const userPayload = {
                ID       : vendorUser.ID || 0,
                VendorID : vendorID,
                FullName : vendorUser.FullName,
                Email    : vendorUser.Email,
                Phone    : vendorUser.Phone,
                Status   : vendorUser.Status,
            };

            await postVendorUser(userPayload);
            helper.StopProcessing(btn);
            onDismissModal();
            onSave();

            swal.fire({
                toast             : true,
                icon              : 'success',
                titleText         : vendorUser.ID ? 'Vendor user updated successfully!' : 'Vendor user added successfully!',
                position          : 'bottom-end',
                showConfirmButton : false,
                timer             : 1500,
                animation         : false,
                customClass       : { popup: 'margin-20' },
            });
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon               : 'error',
                titleText          : 'Error!',
                text               : err.message,
                buttonsStyling     : false,
                confirmButtonClass : 'btn btn-brand',
            });
        }
    };

    return (
        <div className="modal fade" id="vendor-user-add-modal" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{vendorUser.ID ? 'Edit Vendor User' : 'Add Vendor User'}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form className="kt-form" id="add-vendor-user-form">
                            <div className="kt-form kt-form--label-right padding-10" role="form">

                                <div className="form-group row">
                                    <label className="col-form-label col-lg-3">Name <span className="red">*</span></label>
                                    <div className="col-lg-8">
                                        <input
                                            id="txtUserName"
                                            name="txtUserName"
                                            type="text"
                                            className="form-control"
                                            value={vendorUser.FullName || ''}
                                            onChange={(e) => updateVendorUserField('FullName', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-form-label col-lg-3">Email <span className="red">*</span></label>
                                    <div className="col-lg-8">
                                        <input
                                            id="txtUserEmail"
                                            name="txtUserEmail"
                                            type="text"
                                            className="form-control"
                                            value={vendorUser.Email || ''}
                                            onChange={(e) => updateVendorUserField('Email', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-form-label col-lg-3">Phone <span className="red">*</span></label>
                                    <div className="col-lg-8">
                                        <input
                                            id="txtUserPhone"
                                            name="txtUserPhone"
                                            type="text"
                                            className="form-control"
                                            value={vendorUser.Phone || ''}
                                            onChange={(e) => updateVendorUserField('Phone', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-form-label col-lg-3">Active</label>
                                    <div className="col-lg-8">
                                        <span className="kt-switch kt-switch--icon">
                                            <label>
                                                <input
                                                    id="chkUserActive"
                                                    name="chkUserActive"
                                                    type="checkbox"
                                                    checked={!!vendorUser.Status}
                                                    onChange={(e) => updateVendorUserField('Status', e.target.checked ? 1 : 0)}
                                                />
                                                <span></span>
                                            </label>
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                        <button id="btnSaveVendorUser" type="button" className="btn btn-brand" onClick={addVendorUserHandler}>Save</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddVendorUserModal;
